let locationOrigin = typeof window === 'undefined' ? '' : window.location.origin
if (!locationOrigin || locationOrigin.indexOf('localhost') > -1) {
  // 打开使用本地mock，需要连测试环境可以使用ip地址或注释这行
  // locationOrigin = locationOrigin + '/gov'
}

const domain = locationOrigin + '/api/galaxy'
const ares = locationOrigin + '/api/ares/inner/galaxy'
const school = locationOrigin + '/api/schoolprivate'
const mockexam = locationOrigin + '/api/mockexam'

const getReportMobileOrigin = () => {
  let env = 'test'
  const reportMobileOriginMap = {
    test: 'https://windmill.test.meituan.com',
    st: 'https://bikeg.st.meituan.com',
    prod: 'https://bikeg.meituan.com',
  }
  if (typeof window === 'undefined') {
    return reportMobileOriginMap[env]
  }
  if (window.__IS_GALAXY_PROD) {
    env = 'prod'
  } else if (window.__IS_GALAXY_ST) {
    env = 'st'
  }
  return reportMobileOriginMap[env]
}

const api = {
  origin: `${locationOrigin}`,
  // app
  logout: `${domain}/logout`,
  getUserInfo: `${domain}/user/getUserInfo`, // 账号30天到期提示
  getUserPhone: `${domain}/user/getPhone`, // 获取账号手机号
  noticeAccount: `${domain}/effect/notice`, // 检验是否快到期
  getUserResources: `${domain}/permission/getResources`,
  getWeather: `${domain}/query/getWeather`,
  // resource
  getAllResources: `${domain}/resource/getAllResources`,
  // entity
  entityQuerySubDistrict: `${domain}/area/entity/districtList`,
  entityQueryTownList: `${domain}/area/entity/townList`,
  queryAreaCityList: `${domain}/area/cityList`,
  // common
  commonQueryOperateLog: `${domain}/common/oprateLog/query`,
  commonOptions: `${domain}/common/label`,
  searchStaff: `${ares}/searchStaff`,
  createGroup: `${ares}/createGroup`,
  commonQueryDecryptionResult: `${school}/tob/decrypt`,
  bikeReservationFeedbackConfig: `${domain}/bike/reservation/feedback/config`,
  uploadCommon: `${domain}/common/fileUpload`, // 通用上传
  commonFileDownload: `${domain}/common/fileDownload`, // 通用下载
  //***************************************** 数据中心 *****************************************/
  region: `${domain}/region`,
  getAreaInfo: `${domain}/region/area`,
  getBasicInfo: `${domain}/query/getBasicInfo`,
  getMapInfo: `${domain}/query/getMapInfo`,
  getStatisticInfo: `${domain}/query/getStatisticInfo`,
  getOrderAndBikeTrend: `${domain}/query/getOrderAndBikeTrend`,
  getCityInfo: `${domain}/query/getCityInfo`,
  getBikeInfo: `${domain}/query/getBikeInfo`,
  getBikeInfoByBikeId: `${domain}/query/getBikeInfoByBikeId`,
  getBikeDetailByBikeId: `${domain}/query/getBikeDetailByBikeId`,
  getBikeLatestOrderList: `${domain}/orderDetails/queryLastBikeOrderList`,
  getParkingPosition: `${domain}/query/getParkingPosition`,
  getOperationPosition: `${domain}/query/getOpsPosition`,
  getHeatMap: `${domain}/query/getHeatMap`,
  queryCityList: `${domain}/queryCityList`,
  queryUserList: `${domain}/user/search`,
  postNewUser: `${domain}/user/addUser`,
  postUpdateUserBaseinfo: `${domain}/user/updateUserInfo`,
  postUpdateUserAuthinfo: `${domain}/user/updatePermission`,
  getRoleOptions: `${domain}/role/selectRoleByType`,
  getAreaOptions: `${domain}/area/getUserPermissionArea`,
  getEntityOptions: `${domain}/entity/getEntitiesByUser`,
  getLatestOrder: `${domain}/complaintRecord/queryLatest`,
  getAreaCenterPosi: `${domain}/query/getCenterLocation`,
  getParkingPointAlarmList: `${domain}/query/getParkingPointAlarmList`,
  getParkingPointDetail: `${domain}/query/getParkingPointDetail`,
  getUserReserveWorkOrder: `${domain}/bike/reservation/order/list`,
  getUserFeedbackWorkOrder: `${domain}/user/feedback/order/list`,
  getOperatorTrack: `${domain}/ops/operator/track`,
  getBikeOwnerIdentityDistribution: `${school}/tob/statistics/query/bikeOwnerIdentityDistribution`,
  getStatisticsByDealType: `${school}/tob/statistics/query/dealCount/statisticsByDealType`,
  getStatisticsByYearlyCumulative: `${school}/tob/statistics/query/dealCount/statisticsByYearlyCumulative`,
  getSchollStatisticsData: `${school}/tob/statistics/query/getStatisticsData`,
  getBikeDistribution: `${school}/tob/statistics/query/bikeDistribution`,
  //***************************************** 后台管理 *****************************************/
  // 权限管理
  getRoleList: `${domain}/role/selectRole`,
  getRoleInfo: `${domain}/role/selectRoleDetail`,
  addRole: `${domain}/role/addRole`,
  updateRole: `${domain}/role/updateRole`,
  checkAccount: `${domain}/user/checkAccount`,
  validateMis: `${domain}/user/checkMisId`,
  userOperationRecord: `${domain}/userOperationRecord/list`,
  updateRoleResourceBind: `${domain}/role/updateRoleResourceBind`,
  getEntityList: `${domain}/entity/getEntityListByName`,
  getSearchRoleList: `${domain}/role/selectRoleCondition`,
  getAllArea: `${domain}/entity/getAllArea`,
  getEntityDetail: `${domain}/entity/getEntityDetail`,
  updateEntity: `${domain}/entity/updateEntity`,
  addEntity: `${domain}/entity/addEntity`,
  removeEntity: `${domain}/entity/deleteEntity`,
  getEntityDefaultResources: `${domain}/entity/getEntityIgnoreResources`,
  updateEntityResourceName: `${domain}/entity/customizeResource/update`,
  updateEntityRegisterCount: `${domain}/entity/updateEntityRegisteredCount`,
  // ga平台-数据对接管理
  dataPushQueryEntities: `${ares}/entity/list`,
  dataPushQueryEntityDetail: `${ares}/entity/scope`,
  dataPushQueryList: `${ares}/dept/list`,
  dataPushQueryDepLogList: `${ares}/operate/deptLog`,
  dataPushRemoveDep: `${ares}/dept/delete`,
  dataPushQueryDepInterface: `${ares}/func/listDeptFunc`,
  dataPushUpdateStatus: `${ares}/func/updateFuncStatus`,
  dataPushQueryTaskLogList: `${ares}/operate/funcLog`,
  dataPushQueryOperatorList: `${ares}/operate/listOperator`,
  dataPushQueryPushResultList: `${ares}/propel/funcPropelStatistic`,
  dataPushDownloadAttachment: `${ares}/handPush/downloadRecord`,
  dataPushDownloadTemplate: `${ares}/handPush/downloadTemplate`,
  dataPushUploadManualFile: `${ares}/handPush/checkData`,
  dataPushUploadFileType: `${ares}/bike/pushApiExtInfo/uploadExtFile`,
  dataPushUpdateManualPush: `${ares}/handPush/pushData`,
  dataPushQueryTaskDetail: `${ares}/func/getFuncAndTrans`,
  dataPushRemoveInterface: `${ares}/func/delete`,
  dataPushQueryBeanNameOptions: `${ares}/func/getComponents`,
  dataPushAddDeptAndFuncSrv: `${ares}/addDeptAndFuncSrv`,
  dataPushUpdateDeptAndFuncSrv: `${ares}/updateDeptAndFuncSrv`,
  dataPushQueryDepDetail: `${ares}/getDeptAndFuncSrv`,
  dataPushAddFuncConf: `${ares}/addFuncConf`,
  dataPushUpdateFuncConf: `${ares}/updateFuncConf`,
  dataPushQueryTopicInfo: `${ares}/func/getTopicInfo`,
  dataPushQueryTopicDetail: `${ares}/func/getTopicDetail`,
  dataPushAddFilterFuncConf: `${ares}/addDynamicFilterConf`,
  dataPushUpdateFilterFuncConf: `${ares}/updateDynamicFilterConf`,
  dataPushQueryAddFuncDetail: `${ares}/getFuncConf`,
  dataPushQueryFilterFuncDetail: `${ares}/getDynamicFilterConf`,
  dataPushQueryMapFuncDetail: `${ares}/getFieldMappingConf`,
  dataPushAddFieldMapFunc: `${ares}/addFieldMappingConf`,
  dataPushUpdateFieldMapFunc: `${ares}/updateFieldMappingConf`,
  dataPushUpdateFieldTransConf: `${ares}/updateFieldTransConf`,
  dataPushAddFieldTransConf: `${ares}/addFieldTransConf`,
  dataPushQueryFieldTransConfDetail: `${ares}/getFieldTransConf`,
  dataPushUpdateFieldPackConf: `${ares}/updateFieldPackageConf`,
  dataPushAddFieldPackConf: `${ares}/addFieldPackageConf`,
  dataPushQueryFieldPackConfDetail: `${ares}/getFieldPackageConf`,
  dataPushUpdateScheduleTask: `${ares}/dynamic/updateScheduleTask`,
  dataPushCreateScheduleTask: `${ares}/dynamic/createScheduleTask`,
  dataPushQueryScheduleTaskDetail: `${ares}/dynamic/getScheduleTask`,
  dataPushQueryFuncEnumOptions: `${ares}/getFuncEnum`,
  dataPushQueryFilterEnumOptions: `${ares}/getFilterEnum`,
  dataPushQuerySrvEnumOptions: `${ares}/getSrvEnum`,
  dataPushQueryTransEnumOptions: `${ares}/getTransEnum`,
  dataPushTransMethods: `${ares}/transMethods`,
  dataPushQueryPackEnumOptions: `${ares}/getPackEnum`,
  dataPushGetFuncSyncInfo: `${ares}/getFuncInfoAll`,
  dataPushSyncFuncInfo: `${ares}/syncFuncInfoAll`,
  dataPushSyncFuncEnvEnum: `${ares}/getEnvEnum`,
  dataPushResultAlertDetail: `${ares}/notification/conf`,
  dataPushResultAlertSave: `${ares}/notification/update`,
  dataPushAddRetransConf: `${ares}/addRetransConf`,
  dataPushFileTemplateUpsert: `${ares}/fileTemplateUpsert`,
  dataPushGenerateHql: `${ares}/generateHql`,
  dataPushQueryNofileConfDetail: `${ares}/getNofileConf`,
  dataPushQueryFileConfDetail: `${ares}/getFileConf`,
  dataPushQueryCraneConfDetail: `${ares}/getCraneConf`,
  dataPushStaticConfEnumOptions: `${ares}/getStaticConfEnum`,
  dataPushAddNofileConf: `${ares}/addNofileConf`,
  dataPushUpdateNofileConf: `${ares}/updateNofileConf`,
  dataPushAddFileConf: `${ares}/addFileConf`,
  dataPushUpdateFileConf: `${ares}/updateFileConf`,
  dataPushAddCraneConf: `${ares}/addCraneConf`,
  dataPushUpdateCraneConf: `${ares}/updateCraneConf`,
  // 数据对接管理-数据质量检测
  dataQualityMonitorEnu: `${mockexam}/func/pack/field`,
  dataQualityMonitorAdd: `${mockexam}/monitor/conf/addConf`,
  dataQualityMonitorUpdate: `${mockexam}/monitor/conf/updateConf`,
  dataQualityMonitorDetail: `${mockexam}/monitor/conf/queryConf`,
  dataQualityMonitorResource: `${mockexam}/func/metric/support`,

  // ga平台-备案信息管理
  queryAreaQuotaList: `${domain}/area/quotaList`,
  registerManageQueryList: `${domain}/register/searchByCity`,
  registerManageOperate: `${domain}/register/manageOperate`,
  registerManageDownload: `${domain}/register/downloadData`,
  registerManageDownloadTemplate: `${domain}/register/downloadTemplate`,
  registerManageUploadFile: `${domain}/register/fileParse`,
  registerManageTotalDiff: `${domain}/register/totalDiff`,
  registerManageLogList: `${domain}/register/operateRecord`,
  //*****************************************  ga平台-调优策略管理 *****************************************/
  // ga平台-调优策略管理-通用字典接口
  optimizeCommonQueryDict: `${domain}/common/optimize/queryAttributeDict`,
  optimizeCommonDownloadTemplate: `${domain}/optimize/common/download/template`,
  optimizeCommonFileUpload: `${domain}/optimize/common/fileUpload`,
  // ga平台-调优策略管理-白名单调优
  whiteListQueryUserEntities: `${domain}/optimize/entity`,
  whiteListQueryConfig: `${domain}/optimize/queryConfig`,
  whiteListUpdateStatus: `${domain}/optimize/turnOnOff`,
  whiteListQueryEntities: `${domain}/optimize/treeAreaEntity`,
  whiteListQueryCityRealCount: `${domain}/optimize/city/realCount`,
  whiteListChangeConfig: `${domain}/optimize/changeConfig`,
  whiteListChangeConfigManual: `${domain}/bike/whitelist/updateBikeWhiteList`,
  whiteListConfigDetail: `${domain}/optimize/detailConfig`,
  whiteListQueryConfigExist: `${domain}/optimize/config/exist`,
  whiteListUploadFile: `${domain}/bike/whitelist/uploadWhiteListFile`,
  whiteListDownloadBikeWhiteList: `${domain}/bike/whitelist/downloadBikeWhiteList`,
  whiteListResultAlertDetail: `${domain}/notify/getNotifyConf`,
  whiteListResultAlertSave: `${domain}//notify/addOrUpdateNotifyConf`,
  // ga平台-调优策略管理-运维力量调优
  operationOptimizeQueryList: `${domain}/optimize/power/pageQueryOptimizeConfig`,
  operationOptimizeConfigStatus: `${domain}/optimize/power/turnOnOff`,
  operationOptimizeDownloadTemplate: `${domain}/optimize/power/downloadTemplate`,
  operationOptimizeUpload: `${domain}/optimize/power/uploadWhiteListFile`,
  operationOptimizeConfig: `${domain}/optimize/power/upsertOptimizeConfig`,
  operationOptimizeDownloadRecord: `${domain}/optimize/power/downloadBikePowerWhiteList`,
  // ga平台-调优策略管理-虚拟订单配置
  virtualOrderSave: `${domain}/optimize/virtualOrder/config/save`,
  virtualOrderEdit: `${domain}/optimize/virtualOrder/config/update`,
  virtualOrderQueryList: `${domain}/optimize/virtualOrder/config/list`,
  virtualOrderTurnOnOff: `${domain}/optimize/virtualOrder/config/turnOnOff`,
  virtualOrderDelete: `${domain}/optimize/virtualOrder/config/delete`,
  // ga平台-调优策略管理-虚拟定位配置
  virtualPosiQueryList: `${domain}/optimize/virtualPosition/config/list`,
  virtualPosiTurnOnOff: `${domain}/optimize/virtualPosition/config/turnOnOff`,
  virtualPosiDelete: `${domain}/optimize/virtualPosition/config/delete`,
  // virtualPosiQueryOpts: `${domain}/optimize/common/queryAttributeDict`,
  virtualPosiAddConfigSave: `${domain}/optimize/virtualPosition/config/save`,
  virtualPosiRuleDetail: `${domain}/optimize/virtualPosition/config/info`,
  virtualPosiRuleUpdate: `${domain}/optimize/virtualPosition/config/update`,
  virtualPosiRuleAreaQueryAllTown: `${domain}/area/queryAllTown`,
  virtualPosiRulefileUpload: `${domain}/optimize/virtualPosition/bikeList/fileUpload`,
  virtualPosiDownloadBikeList: `${domain}/optimize/virtualPosition/download/bikeListV1`,
  virtualPosiDownloadConflictBikeList: `${domain}/optimize/virtualPosition/download/conflictBikeListV1`,
  // ga平台-调优策略管理-调优目标配置
  areaOptimizeConfigList: `${domain}/optimize/virtualPosition/balance/config/list`,
  areaOptimizeConfigDelete: `${domain}/optimize/virtualPosition/balance/config/delete`,
  areaOptimizeConfigSave: `${domain}/optimize/virtualPosition/balance/config/save`,
  areaOptimizeConfigDetail: `${domain}/optimize/virtualPosition/balance/config/query`,
  //ga平台-调优策略管理-蓝牙信号调优
  bluetoothConfigList: `${domain}/optimize/bluetooth/config/list`,
  bluetoothConfigDelete: `${domain}/optimize/bluetooth/config/delete`,
  bluetoothConfigGetAllArea: `${domain}/entity/getPermissionArea`,
  bluetoothConfigSave: `${domain}/optimize/bluetooth/config/save`,
  bluetoothConfigInfo: `${domain}/optimize/bluetooth/config/info`,
  bluetoothConfigUpdate: `${domain}/optimize/bluetooth/config/update`,
  bluetoothConfigDownloadConflictBikeList: `${domain}/optimize/bluetooth/download/conflictBikeList`,
  bluetoothConfigFileUpload: `${domain}/optimize/bluetooth/bikeList/fileUpload`,
  bluetoothConfigTurnOnOff: `${domain}/optimize/bluetooth/config/turnOnOff`,
  //ga平台-调优策略管理-X项目调优
  xProjectConfigList: `${domain}/optimize/x/config/list`,
  xProjectConfigSave: `${domain}/optimize/x/config/save`,
  xProjectConfigUpdate: `${domain}/optimize/x/config/update`,
  xProjectConfigInfo: `${domain}/optimize/x/config/info`,
  xProjectConfigDelete: `${domain}/optimize/x/config/delete`,
  xProjectConfigFileUpload: `${domain}/optimize/x/bikeList/fileUpload`,
  xProjectConfigDownLoadConflictBikeList: `${domain}/optimize/x/download/conflictBikeList`,
  xProjectBikeExport: `${domain}/optimize/x/bike/export`,
  xProjectBindBikeExport: `${domain}/optimize/x/bindBike/export`,
  xProjectUnbindConfigList: `${domain}/optimize/x/unbind/config/list`,
  xProjectUnbindBikeListFileUpload: `${domain}/optimize/x/unbind/bikeList/fileUpload`,
  xProjectConfigUnbindConfigSave: `${domain}/optimize/x/unbind/config/save`,
  xProjectConfigUnbindConfigInfo: `${domain}/optimize/x/unbind/config/info`,
  //ga平台-调优策略管理-数字哨兵管理
  digitalGuardQueryList: `${domain}/optimize/digital/sentinel/config/list`,
  digitalGuardChangeStatus: `${domain}/optimize/digital/sentinel/config/turnOnOff`,
  digitalGuardAddStratety: `${domain}/optimize/digital/sentinel/config/save`,
  digitalGuardUpdateStratety: `${domain}/optimize/digital/sentinel/config/update`,
  digitalGuardQueryDetail: `${domain}/optimize/digital/sentinel/config/info`,
  digitalGuardDeleteConfig: `${domain}/optimize/digital/sentinel/config/delete`,
  digitalGuardRegisterFileParse: `${domain}/optimize/digital/sentinel/config/fileParse`,
  digitalGuardRegisterDownloadTemplate: `${domain}/optimize/digital/sentinel/config/downloadTemplate`,
  // ga调优-直传数据过滤
  dataFilterConfigList: `${domain}/optimize/directPush/config/list`,
  dataFilterAddStratety: `${domain}/optimize/directPush/config/save`,
  dataFilterEditStratety: `${domain}/optimize/directPush/config/update`,
  dataFilterConfigDetail: `${domain}/optimize/directPush/config/info`,
  dataFilterDeleteConfig: `${domain}/optimize/directPush/config/delete`,
  // ga平台-调优策略管理-数据补传
  supplementOptimizeQueryList: `${domain}/optimize/data/supplement/push/config/list`,
  supplementOptimizeDownloadDetail: `${domain}/optimize/data/supplement/push/failedBike/download`,
  supplementOptimizeConfig: `${domain}/optimize/data/supplement/push/config/save`,
  supplementOptimizeDetail: `${domain}/optimize/data/supplement/push/config/info`,
  // ga平台-调优策略管理-入栏率调优
  dockingRateQueryList: `${domain}/optimize/parkingPoint/config/list`,
  dockingRateTurnOnOff: `${domain}/optimize/parkingPoint/config/turnOnOff`,
  dockingRateDelete: `${domain}/optimize/parkingPoint/config/delete`,
  dockingRateDetailInfo: `${domain}/optimize/parkingPoint/config/info`,
  dockingRateSave: `${domain}/optimize/parkingPoint/config/save`,
  // 后台管理-信用管理-骑行分开通
  creditManageQueryGeneralAreas: `${domain}/creditscore/general/areas`,
  creditManageQueryGeneralRegions: `${domain}/creditscore/general/regions`,
  creditManageQueryCreditList: `${domain}/creditscore/city/list`,
  creditManageSwitchStatus: `${domain}/creditscore/city/modifyStatus`,
  creditManageQueryBehaviors: `${domain}/creditscore/city/behaviorCategory`,
  creditManageCityAdd: `${domain}/creditscore/city/add`,
  creditManageCityEdit: `${domain}/creditscore/city/modify`,
  creditManageQueryCreditDetail: `${domain}/creditscore/city/queryForUpdate`,
  // 后台管理-信用管理-白名单管理
  creditManageQueryWhitelist: `${domain}/creditscore/whitelist/query`,
  creditManageSwitchWhiteListStatus: `${domain}/creditscore/whitelist/update/status`,
  creditManageWhiteListEdit: `${domain}/creditscore/whitelist/edit`,
  creditManageWhiteListAdd: `${domain}/creditscore/whitelist/open`,
  creditManageQueryWhiteListDetail: `${domain}/creditscore/whitelist/detail`,
  // 后台管理-信用管理-用户负面清单
  creditManageQueryBannedList: `${domain}/user/ban/list`,
  creditManageBannedDownloadData: `${domain}/user/ban/list/download`,
  creditManageBannedRevoke: `${domain}/user/ban/cancel`,
  creditManageBannedDownloadTemplate: `${domain}/user/ban/downloadTemplate`,
  creditManageBannedFileParse: `${domain}/user/ban/fileParse`,
  creditManageBannedAdd: `${domain}/user/ban/add`,
  creditManageBannedDetail: `${domain}/user/ban/detail`,

  //***************************************** 管理中心 *****************************************/
  // 管理中心-备案扫码信息
  registerBrandSearch: `${domain}/beian/search`,
  registerBrandExport: `${domain}/beian/export`,
  // 管理中心-投诉工单
  queryComplaintStatus: `${domain}/complaintRecord/queryComplaintStatus`,
  queryOrderCityList: `${domain}/complaintRecord/queryCityList`,
  queryStreetList: `${domain}/complaintRecord/queryStreetInfoByRegion`,
  queryWechatList: `${domain}/complaintRecord/queryWechatGroup`,
  queryComplaintList: `${domain}/complaintRecord/queryList`,
  queryComplaintDetail: `${domain}/complaintRecord/queryRecordDetail`,
  // 管理中心-厂商总量检测
  firmTestQueryRegionList: `${domain}/bluetooth/company/regionList`,
  firmTestQueryCityList: `${domain}/bluetooth/company/cityList`,
  firmTestQueryAreaList: `${domain}/bluetooth/company/areaList`,
  firmTestQuerySteetList: `${domain}/bluetooth/company/townList`,
  firmTestQueryFenceList: `${domain}/bluetooth/company/fenceList`,
  firmTestQueryFirmList: `${domain}/bluetooth/company/sniffingSituation`,
  firmTestQueryH3GridInfo: `${domain}/bluetooth/company/h3GridInfo`,
  // 管理中心-车辆管理
  bikeManageQuerySubRegion: `${domain}/bikeManage/queryBikeManageSubRegion`,
  bikeManageQueryBikeList: `${domain}/bikeManage/queryByPage`,
  bikeManageQueryRadingTrack: `${domain}/orderDetails/queryRidingTrack`,
  bikeManageQueryStatisticsStatus: `${domain}/bikeManage/statistics/status`,
  bikeManageQueryStatisticsBattery: `${domain}/bikeManage/statistics/battery`,
  // 管理中心-停车点管理
  parkingManageQueryList: `${domain}/parkingPoint/manage/list`,
  parkingManageQueryDetails: `${domain}/parkingPoint/manage/parkingBikeList`,
  parkingManageUpdateBuffer: `${domain}/parkingPoint/manage/buffer/change`,
  parkingManageExport: `${domain}/parkingPoint/manage/export`,
  // 管理中心-校园管理-通用字典接口
  schoolCommonQueryDictionary: `${school}/tob/user/queryLabels`,
  // 管理中心-校园管理-账号列表
  schoolQueryUserList: `${school}/tob/user/list`,
  schoolUpdateUserStatus: `${school}/tob/user/status`,
  schoolQueryRoleList: `${school}/tob/role/selections`,
  schoolQueryEntityList: `${school}/tob/entity/selections`,
  schoolQueryDeptList: `${school}/tob/dept/getDeptTree`,
  schoolQueryDeptListWithDeptId: `${school}/tob/dept/getDeptTreeWithEchoData`,
  schoolQueryJobList: `${school}/tob/job/selections`,
  schoolQueryLogList: `${school}/logRecord/queryLog`,
  schoolBatchAddUserFile: `${school}/tob/user/add/batch/validate`,
  schoolBatchAddUser: `${school}/tob/user/add/batch`,
  schoolUpdateUser: `${school}/tob/user/edit`,
  schoolAddUser: `${school}/tob/user/add`,
  schoolQueryUserDetail: `${school}/tob/user/detail`,
  schoolUserDownloadTemplate: `${school}/tob/user/add/batch/download`,
  schoolUserQueryShowField: `${school}/tob/user/queryShowField`,

  // 管理中心-校园管理-设备管理
  schoolRfidDeviceList: `${school}/tob/device/list`,
  schoolRfidDeviceEdit: `${school}/tob/device/edit`,
  schoolRfidDeviceStatusChange: `${school}/tob/device/status/change`,
  schoolRfidDeviceDelete: `${school}/tob/device/delete`,
  schoolRfidPassageRecordList: `${school}/tob/rfid/passage/record/list`,
  schoolRfidPassageRecordDownload: `${school}/tob/rfid/passage/record/list/download`,
  schoolRfidDeviceConfigDetail: `${school}/tob/device/config/detail`,
  schoolRfidDeviceConfigSave: `${school}/tob/device/config`,
  schoolRfidDeviceRelationDevice: `${school}/tob/device/id/list`,

  // 管理中心-校园管理-配置中心
  schoolConfigCenterList: `${school}/tob/job/list`,
  schoolConfigDeleteJob: `${school}/tob/job/delete`,
  schoolConfigQueryJobList: `${school}/tob/job/list`,
  schoolConfigAddJob: `${school}/tob/job/add`,
  schoolConfigEditJob: `${school}/tob/job/edit`,
  schoolConfigQueryJobDetail: `${school}/tob/job/detail`,
  schoolConfigUploadImg: `${school}/image/upload`,
  schoolConfigQueryMPDetail: `${school}/tob/entity/query`,
  schoolConfigEditMP: `${school}/tob/entity/edit`,
  schoolConfigDownLoadDept: `${school}/tob/dept/downloadTemplate`,
  schoolConfigUploadDept: `${school}/tob/dept/upload`,
  schoolConfigUpdateDept: `${school}/tob/dept/update`,
  schoolConfigDeleteDept: `${school}/tob/dept/delete`,
  schoolConfigAddDept: `${school}/tob/dept/add`,
  schoolConfigSortDept: `${school}/tob/dept/sort`,
  schoolConfigQueryDealTypes: `${school}/tob/bike/deal/type/list`,
  schoolConfigDealStatus: `${school}/tob/bike/deal/type/status`,
  schoolConfigDeleteDeal: `${school}/tob/bike/deal/type/delete`,
  schoolConfigQueryDealDetail: `${school}/tob/bike/deal/type/detail`,
  schoolConfigQueryDealComponents: `${school}/tob/bike/deal/components`,
  schoolConfigQueryNoticeChannels: `${school}/tob/bike/deal/notice/channels`,
  schoolConfigEditDeal: `${school}/tob/bike/deal/type/edit`,
  schoolConfigAddDeal: `${school}/tob/bike/deal/type/add`,
  schoolConfigQueryBikeTypes: `${school}/tob/entity/bikeTypes`,
  schoolConfigQueryAnnounceInfo: `${school}/tob/entity/queryAnnounceInfo`,
  schoolConfigDistributeConfigEdit: `${school}/tob/chart/config/update`,
  schoolConfigDistributeConfigQueryDetail: `${school}/tob/chart/config/query`,
  schoolConfigRidingScoreConfigSave: `${school}/tob/cycling/score/config/save`,
  schoolConfigRidingScoreConfigDetail: `${school}/tob/cycling/score/config/query`,
  schoolConfigRegisterConfigQuery: `${school}/tob/function/settings/account/register/time/setting/query`,
  schoolConfigRegisterConfigSave: `${school}/tob/function/settings/account/register/time/setting/save`,
  // 管理中心-校园管理-车辆备案号管理
  schoolConfigBikeMarkQueryList: `${school}/tob/bike/mark/list`,
  schoolConfigBikeMarkChangeStatus: `${school}/tob/bike/mark/change/status`,
  schoolConfigBikeMarkDelete: `${school}/tob/bike/mark/delete`,
  schoolConfigBikeMarkAdd: `${school}/tob/bike/mark/add`,
  schoolConfigBikeMarkUpdate: `${school}/tob/bike/mark/update`,
  schoolConfigBikeMarkLogList: `${school}/tob/bike/no/query/changeRecord`,
  // 管理中心-校园管理-车辆备案号管理
  schoolbikeRecordList: `${school}/tob/bike/no/list`,
  schoolbikeRecordDeleList: `${school}/tob/bike/no/delete`,
  schoolbikeRecordStatus: `${school}/tob/bike/no/status`,
  schoolbikeRecordAddList: `${school}/tob/bike/no/add`,
  schoolbikeRecordCheckBack: `${school}/tob/bike/no/checkBikeNoBindStatus`,
  schoolbikeRecordBatchDelDownloadTemplate: `${school}/tob/bike/no/delete/downloadTemplate`,
  schoolbikeRecordBatchDelUpload: `${school}/tob/bike/no/delete/excelCheck`,
  schoolbikeRecordBatchDel: `${school}/tob/bike/no/deleteBatch`,
  schoolbikeDataRepair: `${school}/tob/bike/no/send/rfid`,
  schoolbikeRecordBikeDetail: `${school}/tob/bike/no/bind/bike/detail`,
  schoolbikeRecordBikeLostDetail: `${school}/tob/bike/no/lost/detail`,
  schoolbikeRecordActivate: `${school}/tob/bike/no/activate`,
  // 管理中心-校园管理-车辆管理
  schoolbikeManageList: `${school}/tob/bike/info/list`,
  schoolbikeManageEditList: `${school}/tob/bike/info/edit`,
  schoolbikeManageAddList: `${school}/tob/bike/info/add`,
  schoolQueryBikeTypeList: `${school}/tob/bike/info/getBikeType`,
  schoolbikeManageEchoList: `${school}/tob/bike/info/detail`,
  schoolbikeManagePhone: `${school}/tob/bike/info/checkPhone`,
  schoolbikeManageBatchAdd: `${school}/tob/bike/info/addBatch`,
  schoolbikeManageBatchAddDownloadTemplate: `${school}/tob/bike/info/downloadTemplate`,
  schoolbikeManageBatchAddUpload: `${school}/tob/bike/info/addBatch/excelCheck`,
  schoolbikeManageDealDownloadTemplate: `${school}/tob/bike/deal/downloadTemplate`,
  schoolbikeManageDealUpload: `${school}/tob/bike/deal/excelCheck`,
  schoolbikeManageBatchUnbindDownloadTemplate: `${school}/tob/bike/info/unbindBikeNo/downloadTemplate`,
  schoolbikeManageBatchUnbindUpload: `${school}/tob/bike/info/unbindBikeNo/excelCheck`,
  schoolBikeManageUnbindBikeNo: `${school}/tob/bike/info/unbindBikeNo`,
  schoolBikeManageDownloadData: `${school}/tob/bike/info/list/download`,
  schoolbikeManageLostDetail: `${school}/tob/bike/info/lost/detail`,
  schoolBikeManageUnlost: `${school}/tob/bike/info/unlost`,
  schoolBikeManageBatchUpdateNoValidity: `${school}/tob/bike/info/batchUpdateNoValidityByJob`,
  schoolBikeManageQueryValidityLogList: `${school}/tob/bike/info/query/batchUpdateNoValidity`,
  schoolBikeManageBatchUpdateNoValidityBySegment: `${school}/tob/bike/info/batchUpdateNoValidityBySegment`,
  schoolBikeManageBindBikeNo: `${school}/tob/bike/info/bind`,
  // 管理中心-校园管理-车辆处置记录
  schoolDealAddBikeDeal: `${school}/tob/bike/deal`,
  schoolDealRecordQueryDealTypes: `${school}/tob/bike/deal/type/selection`,
  schoolDealRecordQueryDealOrigins: `${school}/tob/bike/deal/origin`,
  schoolDealQueryDealRecordList: `${school}/tob/bike/deal/list`,
  schoolDealRecordDownloadData: `${school}/tob/bike/deal/list/download`,
  schoolDealRecordQueryDetail: `${school}/tob/bike/deal/detail`,
  schoolDealRecordDelete: `${school}/tob/bike/deal/delete`,
  schoolDealRecordBikeMark: `${school}/tob/bike/deal/bikeMark/deal`,
  // 管理中心-校园管理-外呼记录
  schoolBreatheRecordList: `${school}/tob/dial/page`,
  schoolBreatheRecordExport: `${school}/tob/dial/export`,
  schoolBreatheRecordTypeDict: `${school}/tob/dial/typeDict`,
  // 管理中心-校园管理-消息提醒
  schoolMessageReminderAdd: `${school}/tob/bike/noticeConfig/add`,
  schoolMessageReminderUpdate: `${school}/tob/bike/noticeConfig/update`,
  schoolMessageReminderList: `${school}/tob/bike/noticeConfig/list`,
  schoolMessageReminderStatus: `${school}/tob/bike/noticeConfig/status`,
  schoolMessageReminderDelete: `${school}/tob/bike/noticeConfig/delete`,
  schoolMessageReminderDetail: `${school}/tob/bike/noticeConfig/query`,
  // 管理中心 自由车管理 隐私号报备
  schoolMessageReportList: `${school}/tob/privacy/realName/report/list`,
  schoolMessageReportAdd: `${school}/tob/privacy/realName/report/add`,
  schoolMessageReportEdit: `${school}/tob/privacy/realName/report/edit`,
  schoolMessageReportDelete: `${school}/tob/privacy/realName/report/delete`,
  schoolMessageImagePrivateUpload: `${school}/image/private/upload`,
  schoolMessageReportDetail: `${school}/tob/privacy/realName/report/info`,

  // 管理中心-用户信用分管理
  userCreditManageQueryRegions: `${domain}/region/regionList`,
  userCreditManageQuerylist: `${domain}/creditscore/behavior/list`,
  userCreditManageBehaviorWithdraw: `${domain}/creditscore/behavior/withdraw`,
  userCreditManageAddBehavior: `${domain}/creditscore/behavior/add`,
  userCreditManageUserUpload: `${domain}/creditscore/behavior/fileParse`,
  creditManageQueryDeductBehaviors: `${domain}/creditscore/behavior/deductionBehaviorCategory`,
  userCreditManageDownloadUserTemplate: `${domain}/creditscore/behavior/downloadTemplate`,
  // 管理中心-运维工单
  operationOrderQueryOrderTypes: `${domain}/ops/order/types`,
  operationOrderQueryRegions: `${domain}/ops/order/areas`,
  operationOrderQueryOrderList: `${domain}/ops/order/list`,
  // 管理中心-运维人员
  operationUserList: `${domain}/ops/operator/list`,
  getPositionTypeOptions: `${domain}/ops/operator/positionType`,
  getRealPhoneNo: `${domain}/ops/decryption/phoneNum`, // 通过token获取明文手机号
  // 管理中心-订单管理
  orderManageQueryList: `${domain}/orderDetails/queryPage`,
  orderManageQueryPayStatusOpts: `${domain}/orderDetails/queryPayStatusList`,
  // 管理中心-牌照屏蔽词配置
  blockingWordsConfigList: `${domain}/beian/maskword/search`,
  blockingWordsConfigDelete: `${domain}/beian/maskword/delete`,
  blockingWordsConfigCreate: `${domain}/beian/maskword/create`,
  blockingWordsConfigUpdate: `${domain}/beian/maskword/update`,
  // 管理中心 - 重码/牌提醒配置
  duplicateCodeConfigList: `${domain}/beian/repeatalert/search`,
  duplicateCodeConfigDelete: `${domain}/beian/repeatalert/delete`,
  duplicateCodeConfigUpdate: `${domain}/beian/repeatalert/update`,
  duplicateCodeConfigCreate: `${domain}/beian/repeatalert/create`,
  duplicateCodeConfigFileUpload: `${domain}/beian/repeatalert/fileParse`,
  // 管理中心-汇报页面管理
  getReportTemplateList: `${domain}/report/template/list`, // 获取模板列表
  getReportTemplate: `${domain}/report/template/detail`, // 获取模板详情信息
  createReport: `${domain}/report/page/create`, // 创建报告
  updateReport: `${domain}/report/page/modify`, // 更新报告
  getReportList: `${domain}/report/page/list`, // 汇报页列表页查询
  getReportById: `${domain}/report/page/detail`, // 报告详情，包含s3链接
  getReportByIdFromMobile: `${domain}/report/page/detailForMobile`, // 报告详情，移动端使用，没有登录鉴权
  getReportByIdFromMobileV2: `${getReportMobileOrigin()}/g/governor/report/reportDetailForMobile`, // 报告详情，移动端使用，新接口
  reportChangeStatus: `${domain}/report/page/changeStatus`, // 变更报告状态
  getReportRegions: `${domain}/report/page/regions`, // 查询条件-行政区域 regions
  getReportIndexData: `${domain}/report/index/data`, // 获取模板内业务基础数据
  printReport: `${domain}/report/page/printOrderPage`, // 用于记录打印操作
  // 管理中心-专属车管理
  exclusiveUserInfo: `${domain}/windmill/queryUser`,
  exclusiveBikeInfo: `${domain}/windmill/queryBike`,
  exclusiveBikeRecordInfo: `${domain}/windmill/queryRecord`,
  exclusiveBikeTrace: `${domain}/windmill/queryTrace`,
  exclusiveDecrypt: `${domain}/windmill/decrypt`,
  // 管理中心-用户车辆预约信息
  userVehicleReservationInfoList: `${domain}/bike/reservation/list`, // 车辆预约列表
  userVehicleReservationInfoExport: `${domain}/bike/reservation/export`, // 点击导出按钮
  userVehicleReservationInfoOptimizeSubmit: `${domain}/bike/reservation/optimize/commit`, // 调优详情提交
  userVehicleReservationInfoDelete: `${domain}/bike/reservation/delete`, // 车辆预约删除
  userVehicleReservationInfoReservationCommit: `${domain}/bike/reservation/order/commit`, // 预约工单处理-提交
  userVehicleReservationInfoDownloadTemplate: `${domain}/bike/reservation/download/template`, // 预约工单处理-下载模版
  userVehicleReservationInfoUpload: `${domain}/bike/reservation/upload/file`, // 预约工单处理-上传文件
  userVehicleReservationInfoResponse: `${domain}/bike/reservation/response/info`, // 响应情况-查看详情
  userVehicleReservationInfoOptimizeDetail: `${domain}/bike/reservation/optimize/detail`, // 响应情况-查看详情
  userVehicleReservationConfigSubmit: `${domain}/bike/reservation/notice/config/commit`, // 工单通知提交
  userVehicleReservationConfigDetail: `${domain}/bike/reservation/notice/config/query`, // 工单通知详情

  // 管理中心 用户意见反馈信息
  userFeedbackList: `${domain}/user/feedback/list`, // 查询意见反馈信息列表
  userFeedbackExport: `${domain}/user/feedback/export`, // 导出意见反馈信息
  userFeedbackDelete: `${domain}/user/feedback/delete`, // 意见反馈信息删除
  userFeedbackCommit: `${domain}/user/feedback/order/commit`, // 用户意见反馈工单处理-提交
  userFeedbackDownloadTemplate: `${domain}/user/feedback/download/template`, // 用户意见反馈工单处理-下载模版
  userFeedbackResponseInfo: `${domain}/user/feedback/response/info`, // 响应情况-查看详情
  userCommonSearchMisInfo: `${domain}/common/misInfo/search`, // 获取mis号
  userFeedbackConfigSubmit: `${domain}/user/feedback/notice/config/commit`, // 工单通知提交
  userFeedbackConfigDetail: `${domain}/user/feedback/notice/config/query`, // 工单通知详情

  // 管理中心 违法小广告识别
  advertisingPageQuery: `${domain}/advertising/pageQuery`, // 查询
  advertisingTypeQuery: `${domain}/advertising/type`, // 查询广告类别列表
  advertisingExport: `${domain}/advertising/export`, // 导出广告识别数据
  advertisingImport: `${domain}/advertising/commit`, // 批量导入广告图片

  // 管理中心 新国标认证车辆管理
  gbcertifiedVehicleManageGetBikeInfo: `${domain}/iot/getCertificationBikeInfo`,
  gbcertifiedVehicleManageGetActiveBikeInfo: `${domain}/iot/getCertificationBikeActiveInfo`,
  gbcertifiedVehicleManageGetActiveBatteryInfo: `${domain}/iot/getCertificationBatteryActiveInfo`,

  // **************************** H5 ************************
  h5ReservationCommit: `${domain}/bike/reservation/commit`, // 用户车辆预约信息记录提交
  h5FeedbackCommit: `${domain}/user/feedback/commit`, // 用户意见反馈记录提交
  h5FeedbackUploadPhoto: `${domain}/user/feedback/upload/photo`, // H5使用上传图片

  // **************************** 违规事件中心 ************************
  violationEventList: `${school}/tob/event/list`, // 违规事件列表
  violationEventStatistics: `${school}/tob/statistics/query/event/quantity`, // 违规事件统计
  violationEventLogList: `${domain}/ops/violation/event/log/list`, // 违规事件日志列表
  violationEventAudit: `${school}/tob/event/audit`, // 违规事件审核
}

module.exports = api
